import type { HostPoolUUID } from "@/modules/pools/hostPoolsQuery.ts";
import type { VirtualMachine } from "@warrenio/api-spec/spec.oats.gen";

/** Both fields are optional to support both "Create" and existing VM use cases */
export type VmPoolFields = Partial<Pick<VirtualMachine, "current_pool_uuid" | "designated_pool_uuid">>;

export function getOptionalVmPool(vm: VmPoolFields): HostPoolUUID | null {
    return vm.current_pool_uuid ?? vm.designated_pool_uuid ?? null;
}
